import gsap from 'gsap'

class Cookie {
  constructor() {
    this.cookie = document.querySelector('.c-cookie')
    if (!this.cookie) return
    this.init()
  }

  init() {
    this.btn = this.cookie.querySelector('button')
    this.retrieve()
    this.listener()
  }

  listener() {
    this.btn.addEventListener('click', () => {
      this.hide()
      this.save()
    })
  }

  retrieve() {
    this.localStorage = localStorage.getItem('cookie')

    if (this.localStorage !== 'true') {
      this.show()
    }
  }

  save() {
    localStorage.setItem('cookie', 'true')
  }

  hide() {
    gsap.to(this.cookie, { duration: 0.35, autoAlpha: 0, y: -20 })
  }

  show() {
    gsap.to(this.cookie, { duration: 0.35, autoAlpha: 1, y: 0 })
    // unset pointer Events
    this.cookie.style.pointerEvents = 'unset'

    // console.log(this.cookie)
  }
}

export default Cookie
